<pc-dialog-abstract [isMobile]="true">
  <div class="quote-popup-content" content>
    <header>
      <section>
        <p class="headline3-secondary-title">{{ quoteOverviewLabels.yourQuote }}</p>
        <pc-icon [icon]="closeIcon" [size]="'xsmall'" (clickIcon)="closeQuoteOverview()"></pc-icon>
      </section>
      <pc-separator></pc-separator>
      <section>
        <p class="headline4-header-title">{{ quoteOverviewLabels.total }}</p>
        <p class="headline4-header-title">{{ totalPrice() | currency }}</p>
      </section>
      <pc-separator></pc-separator>
    </header>

    <pc-quote-overview-content
      [brokerFee]="quoteOverviewService.brokerFee()"
      [brokerFeeTexts]="quoteOverviewLabels.brokerFeeTexts"
      [destinationsToggleOptions]="quoteOverviewLabels.destinationsToggleOptions"
      [emailQuoteTexts]="quoteOverviewLabels.emailQuoteTexts"
      [gstRate]="gstRate"
      [privacyPolicyLink]="privacyPolicyLink"
      [quoteCoversData]="quoteCoversData"
      [quoteTripDetailsData]="quoteTripDetailsData"
      [selectedDestinationAlt]="quoteOverviewLabels.destinationAltPrefix"
      [showBrokerFeeSection]="processType() === ProcessTypes.AGENTS"
      [showEmailSection]="showEmailSection()"
      [travelersAmountText]="quoteOverviewLabels.travelersAmount"
      [tripDetailsIcons]="tripDetailsIcons"
      (brokerFeeChange)="setBrokerFee($event || 0)"
    >
    </pc-quote-overview-content>
  </div>
</pc-dialog-abstract>
